import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.SimpleAccordionRoot),
  () => import('./SimpleAccordion'),
  (SimpleAccordion) => {
    ComponentUtil.binder(Hooks.SimpleAccordionRoot, SimpleAccordion);
  },
);
